import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IFinanceDashboardData, ITimeRangeParams } from 'src/apis/dashboard/dashboard.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardFinanceKey = 'get-dashboard-finance';

export const useDashboardFinanceHook = (
  params?: ITimeRangeParams,
  options?: UseQueryOptions<IFinanceDashboardData, TQueryError>
): UseQueryResult<IFinanceDashboardData, TQueryError> => {
  const { getFinanceDashboardData } = useDashboardService();

  return useQuery<IFinanceDashboardData, TQueryError>({
    queryKey: [getDashboardFinanceKey, params],
    queryFn: () => getFinanceDashboardData(params),
    enabled: true,
    ...options,
  });
};
